import { Vue } from "vue-property-decorator";
import { store } from "store";
import VueRouter from "vue-router";
VueRouter.prototype.clearHistory = function () {
    if (this.history.stack) {
        this.history.stack = this.history.current ? [this.history.current] : [];
        this.history.index = this.history.current ? 0 : -1;
    }
};
Vue.mixin({
    computed: {
        $store: function () { return store; },
    }
});
function hasRouted(vue) {
    return (typeof vue["routed"] == "function");
}
function callRouted(vue) {
    if (hasRouted(vue))
        vue["routed"](vue.$route.params, vue.$route.query);
}
export default {
    created: function () {
        var _this = this;
        if (hasRouted(this)) {
            callRouted(this);
            this.$watch("$route", function () { return callRouted(_this); });
        }
    },
    computed: {
        root: function () { return this.$root; },
    },
    methods: {
        $reload: function () {
            this.$resetData();
            callRouted(this);
        },
        $resetData: function () {
            Object.assign(this.$data, (typeof this.$options.data == "function")
                ? this.$options.data.apply(this)
                : this.$options);
        },
        $showDialog: function () {
            return this.$root.showDialog.apply(this, arguments);
        }
    },
};
